import { ViewModel } from 'app/viewmodels/view-model';
import { HierarchyTemplateAttribute } from '../admin/hierarchy-templates/hierarchy-template-attribute';
import { HierarchyAttributeInputTableTemplate } from '../admin/table-attribute-template/hierarchy-attribute-input-table-template';

export class HierarchyAttributeInput implements ViewModel {
  public readonly friendlyTypeNameSingular: string = 'Hierarchy Attribute Input';
  public readonly apiRoute: string = '';

  public hierarchyAttributeInputId: string;
  public orgTreeNodeId: string;
  public hierarchyTemplateAttributeId: string;
  public hierarchyTemplateAttribute: HierarchyTemplateAttribute;
  public hierarchyAttributeInputTableTemplateId: string;
  public hierarchyAttributeInputTableTemplate: HierarchyAttributeInputTableTemplate;
  public value: string;

  public json(): HierarchyAttributeInput {
    return this;
  }

  public loadFromJson(data: any): void {
    this.hierarchyAttributeInputId = data.hierarchyAttributeInputId;
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.hierarchyTemplateAttributeId = data.hierarchyTemplateAttributeId;
    this.value = data.value;

    if (data.hierarchyTemplateAttribute) {
      this.hierarchyTemplateAttribute = data.hierarchyTemplateAttribute;
    }

    if (data.hierarchyAttributeInputTableTemplate) {
      this.hierarchyAttributeInputTableTemplate = data.hierarchyAttributeInputTableTemplate;
    }
  }
}
